module.exports = __webpack_public_path__ + "img/wossnewlogo.f67a85e5.png";